/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_EmptyInputs */

const en_settings_tickets_empty = /** @type {(inputs: Settings_Tickets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tickets yet`)
};

/**
* | output |
* | --- |
* | "No tickets yet" |
*
* @param {Settings_Tickets_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_empty = /** @type {((inputs?: Settings_Tickets_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_empty(inputs)
});
export { settings_tickets_empty as "settings.tickets.empty" }